import styled from "@emotion/styled";
import * as React from "react";
import { FC } from "react";
import { IconTypeE } from "../../../assets/icons/Icons";
import FlexBox, { CustomWidthE } from "../../../components/FlexBox";
import Icon from "../../../components/Icon";
import { rem, theme } from "../../../styling/theme";
import { AnimationOverlay, Line } from "../PlaceholderLoader";

const CampaignCardCover = styled(FlexBox)({
  height: "65%",
  backgroundColor: theme.color.greyLightColor,
});

const CampaignCardContent = styled(FlexBox)({
  height: "35%",
  padding: rem(16),
});

const Wrapper = styled(FlexBox)({
  position: "relative",
  width: "24%",
  margin: "0.5%",
  height: rem(350),
  border: `1px solid ${theme.color.greyLightColor}`,
  backgroundColor: theme.color.whiteColor,
  borderRadius: rem(16),
  overflow: "hidden",

  [theme.media.maxLg]: {
    width: "32%",
  },

  [theme.media.maxSm]: {
    width: "49%",
  },

  [theme.media.maxS]: {
    width: "100%",
    margin: 0,
  },
});

const CampaignCardPlaceholder: FC<{}> = () => (
  <Wrapper>
    <AnimationOverlay />
    <FlexBox
      customWidth={CustomWidthE.full}
      fullHeight={true}
      flexDirection="column"
    >
      <CampaignCardCover customWidth={CustomWidthE.full}>
        <Icon
          icon={IconTypeE.image}
          size={100}
          color={theme.color.whiteColor}
        />
      </CampaignCardCover>
      <CampaignCardContent
        customWidth={CustomWidthE.full}
        alignItems="flex-start"
        justifyContent="space-between"
        flexDirection="column"
      >
        <Line />
        <Line />
        <Line />
      </CampaignCardContent>
    </FlexBox>
  </Wrapper>
);

export default CampaignCardPlaceholder;
